class StockService {
  constructor(stockServiceClient, templateContext) {
    this._pack1Uom = templateContext.pack1Uom;
    this._pack2Uom = templateContext.pack2Uom;
    this._stockServiceClient = stockServiceClient;
  }

  fetchStockAvailability = async (productCode, quantity, branchId) => {
    const data = await this._stockServiceClient.fetchStockAvailability(productCode, quantity, branchId);
    const productStockStatus = data.productStockStatus ? this._transformStockAvailabilityData(data.productStockStatus) : [];
    const showBranchSelector = data.showBranchSelector;
    return { productStockStatus, showBranchSelector };
  };

  _transformStockAvailabilityData = (stockAvailabilityList) => {

    if (!stockAvailabilityList) {
      return {};
    }

    const mapStockAvailability = {};

    if (stockAvailabilityList["pack1Status"]) {
      mapStockAvailability[this._pack1Uom] = stockAvailabilityList.pack1Status;
    }

    if (stockAvailabilityList["pack2Status"]) {
      mapStockAvailability[this._pack2Uom] = stockAvailabilityList.pack2Status;
    }

    return mapStockAvailability;
  }

}

export default StockService;